import { render, staticRenderFns } from "./my_details.vue?vue&type=template&id=678f1e8b&scoped=true&"
import script from "./my_details.vue?vue&type=script&lang=js&"
export * from "./my_details.vue?vue&type=script&lang=js&"
import style0 from "./my_details.vue?vue&type=style&index=0&id=678f1e8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678f1e8b",
  null
  
)

export default component.exports